export const introduce = {
  text: '该指标统计了矿工从交易费用中获取收入所占的百分比。',
  height: 1200,
};
